<template>
<div class="payment">
<el-table
      :data="url"
      style="width: 100%">
      <el-table-column
        prop="ok"
        label="支付状态"
        width="180">
      </el-table-column>
      <el-table-column
        prop="points"
        label="支付金额"
        width="180">
      </el-table-column>
      <el-table-column
        prop="tradeId"
        label="订单号">
      </el-table-column>
    </el-table>
</div>
</template>

<script>
export default{
  name:'payment',
  data(){
    return {
      url:[]
    }
  },
  created() {
  },
  mounted() {
    this.getpayment()
  },
  methods:{
    getpayment() {
      // let data = this.url

      let data = sessionStorage.getItem('urle')
      this.$store.dispatch('getPayment',data).then((res) => {
        console.log(res)
        if(res.data.code == 0) {
          this.url = [{
            points:res.data.points,
            tradeId:res.data.trade_id,
            ok:res.data.errmsg
          }]
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.payment {
  width: 100vh;
  height: 75vh;
  background-color: red;
}
</style>
